import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a249b5e38ca1200149fa685_1785885603931_90feb7f8/rafeeq/src/app/order-receipt/page.tsx");
